<template>
  <div class="video-wrapper" :class="{ 'half-chat': halfChat }">
    <v-responsive
      class="video"
      :aspect-ratio="
        halfChat ? (['sm', 'xs'].includes($size) ? 376 / 591 : 1) : 14.2 / 8
      "
    >
      <div
        v-if="value.vimeo_id"
        class="vimeo-wrapper"
        :class="{ 'sticky-video': this.scrollPosition > 300 }"
      >
        <VimeoPlayer
          :vimeo-id="value.vimeo_id"
          :vimeo-chapter="value.vimeo_chapter"
          :first-start-at="firstStartAt"
          :key="value.vimeo_id"
        ></VimeoPlayer>
      </div>
      <div
        v-else-if="value.youtube_id"
        class="youtube-wrapper"
        :class="{ 'sticky-video': this.scrollPosition > 300 }"
      >
        <YoutubePlayer :youtube-id="value.youtube_id" />
      </div>
      <div v-else-if="value.zoom_link" class="youtube-wrapper">
        <div class="video-wrapper__content video-wrapper__bg">
          <ZoomPlayer
            :title="value.title"
            :start-at="value.start_at"
            :zoom-link="value.zoom_link"
            :event="value"
          />
        </div>
      </div>

      <div class="video-wrapper__content" v-else-if="slides.length">
        <swiper
          ref="instance"
          class="video-wrapper__slider"
          :options="swiperOption"
        >
          <swiper-slide v-for="slide in slides" :key="slide.id">
            <div
              class="video-wrapper__slide-copy"
              v-if="slide.copy_html"
              v-html="slide.copy_html"
            ></div>
            <component
              :is="slide.url ? 'a' : 'div'"
              :href="slide.url"
              target="_blank"
              class="video-wrapper__slide"
              :style="{
                backgroundImage: `url(${slide.preview_urls.slide})`,
                backgroundPositionY: `${slide.background_position || 50}%`,
              }"
            >
            </component>
          </swiper-slide>

          <div
            v-if="slides.length > 1"
            class="swiper-button-prev"
            slot="button-prev"
          ></div>
          <div
            v-if="slides.length > 1"
            class="swiper-button-next"
            slot="button-next"
          ></div>
        </swiper>
      </div>
      <div class="video-wrapper__content video-wrapper__bg" v-else></div>
    </v-responsive>
  </div>
</template>

<script>
export default {
  name: "Video",
  props: {
    value: Object,
    firstStartAt: [String, Number],
    halfChat: Boolean,
  },
  data() {
    return {
      swiperOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      scrollPosition: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrollPosition = window.top.scrollY;
    },
  },
  computed: {
    slides() {
      return this.value.filtered_slides.filter((slide) => slide.preview_urls);
    },
  },
};
</script>

<style scoped lang="scss">
.video {
  width: 100%;
  position: relative;
  max-height: 65vh;
  background: #000;
  min-height: 200px;

  &-wrapper {
    &__content {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
    }
    &__bg {
      background-size: cover;
      background-position: center;
      background-image: url("~@/assets/video-placeholder-1.jpg");
    }

    &__slider,
    &__slide {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-position: center;
      display: block;
    }

    &__slide-copy {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 10%;

      color: white;
    }

    &.half-chat {
      .video-wrapper__slide {
        background-size: cover;
      }
    }
  }
}

.video::v-deep .vimeo-player {
  &,
  iframe {
    width: 100%;
    height: 100%;
  }
}

.vimeo-wrapper {
  width: 100%;
  height: 100%;
}

.swiper-button-prev {
  left: 0;
}

.swiper-button-next {
  right: 0;
}

.swiper-button-prev,
.swiper-button-next {
  color: white;
  height: 100%;
  transform: translateY(0);
  top: 0;
  width: 50px;
}

@media screen and (min-width: 960px) {
  .sticky-video {
    position: fixed;
    top: 100px;
    width: 40vw;
    width: 400px;
    height: auto;
    transition: top 1s;
    z-index: 10;
    &::before {
      content: "";
      display: block;
      width: 100%;
      padding-bottom: 56.7%;
    }
  }
}
</style>

<style lang="scss">
.video-wrapper__slide-copy {
  h1,
  h2 {
    color: white;
    letter-spacing: -0.02em;
    text-align: center;
    margin: 0;
  }
  h1 {
    font-size: 64px;
    line-height: 73px;
    font-weight: 800;
  }
  h2 {
    font-size: 43px;
    line-height: 50px;
    font-weight: 700;
  }
}

.half-chat {
  .swiper-slide {
    display: flex;
    flex-direction: column;
  }
  .video-wrapper {
    &__slide-copy {
      position: relative;
      background: $jude-darkred;
      align-items: flex-start;
      padding: 20px 42px;
      > h1 {
        font-size: 43px;
        line-height: 50px;
        font-weight: 700;
        text-align: left;
      }
      > h2 {
        font-size: 24px;
        line-height: 30px;
        font-weight: 800;
        text-align: left;
      }
    }
    &__slide {
      height: unset;
      flex-grow: 1;
    }
  }
}

@media screen and (max-width: 960px) {
  .video-wrapper__slide-copy {
    padding-top: 0;
    h1 {
      font-size: 44px;
      line-height: 43px;
      margin-bottom: 1em;
    }
    h2 {
      font-size: 30px;
      line-height: 37px;
    }
  }
  .half-chat {
    .video-wrapper__slide {
      height: unset;
      &::before {
        display: block;
        content: "";
        width: 100%;
        flex-grow: 1;
      }
      &-copy {
        > h1 {
          margin-bottom: 0.5em;
        }
      }
    }
  }
}
</style>
